
export default {
  props: {
    newTagTitle: String,
    newTagInput: String,
    bgColorProps: String
  },
  data: function data() {
    return {
      colorList: ['#53D397', '#20C1BD', '#58DADA', '#0FC9E7', '#3498DB', '#4586FF', '#8983F3', '#AEA1EA', '#FF6699', '#F24D70', '#FF6F6F'],
      input: this.newTagInput,
      showBgColor: ''
    };
  },

  watch: {
    bgColorProps: function bgColorProps(color) {
      this.showBgColor = color || '#53D397';
    }
  },
  mounted: function mounted() {
    this.showBgColor = this.bgColorProps || '#53D397';
  },

  methods: {
    back: function back() {
      this.$emit('back');
    },
    close: function close() {
      this.$emit('close');
    },

    // 点击变色
    changeColor: function changeColor(val) {
      this.$emit('changeColor', val);
    },

    // 创建按钮
    tagCreateSubmit: function tagCreateSubmit() {
      this.$emit('tagCreateSubmit', this.input, this.showBgColor);
    },

    // 取消按钮
    tagCancel: function tagCancel() {
      this.$emit('tagCancel');
    }
  }
};